export const size = {
  textSize1: 12,
  drawerWidth: 104,
  mobileDrawerWidth: '100%',
  marginVertical1: 4,
  headerHeight: 80,
  mobileHeaderHeight: 56,
  screenHorizontalPadding: 64,
  screenVerticalPadding: 84,
  previewTabBarHeight: 56,
  previewTabBarVerticalItemHeight: 80,
  previewTabBarVerticalWidth: 96,
  userAvatarDefaultSize: 65,
  iconButtonDefaultSize: 40,
  previewContainerVeticalMargin: 20,
  previewContainerHorizontalMargin: 56,
  pagePadding: 64,
  verticalPagePadding: 32,
  mobilePagePadding: 16,
  previewCompactMaxWidth: 355,
  galleryCompactListSeparatorSize: 1,
  postListPaddingHorizontal: 24,
  templateLinksHeight: 250,
  adsBoxHeight: 48,
  panelCompactMaxWidth: 400,
};
